import { TextInput } from '@mantine/core';

interface Props {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	width?: string;
}

export function TextInputFilter({
	value,
	onChange,
	placeholder = 'Search...',
	width = '100%',
}: Props) {
	return (
		<TextInput
			value={value}
			onChange={(event) => onChange(event.currentTarget.value)}
			placeholder={placeholder}
			size="sm"
			style={{ width }}
		/>
	);
}
